import React, { useContext, useEffect, useState } from 'react'
import { NavLink, useNavigate, useSearchParams } from 'react-router-dom'
import PageTitle from '../../../Components/PageTitle';
import { ConfigContext } from '../../../Context/ConfigContext';
import axios from 'axios';
import { OverlayLoader } from '../../../Components/Shimmers';
import dayjs from "dayjs";
import { axiosGet } from '../../../Apis/axiosMethods';


const MyCreditNote = () => {

    const navigate = useNavigate();
    const { apiHeaderJson, apiB2BURL, business_ledger_id } = useContext(ConfigContext);

    const [creditNotes, setCreditNotes] = useState([]);
    const [loading, setLoading] = useState(true);

    ////////////////// pagination //////////////////
    const [next, setNext] = useState(false);
    const [prev, setPrev] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const pageFromUrl = Number(searchParams.get("page")) || 1;
    const limitFromUrl = Number(searchParams.get("limit")) || 20;

    const [page, setPage] = useState(pageFromUrl);
    const [limit, setLimit] = useState(limitFromUrl);

    const [total_pages, settotal_pages] = useState(0);
    const [total_records, settoal_records] = useState(0);

    const GetCreditNotes = async () => {
        try {
            setLoading(true);
            const headers = apiHeaderJson;

            const response = await axiosGet(`/Users/GetCreditNotes`, {
                page,
                limit,
                ledger_id: business_ledger_id,
                voucher_type: "Credit Note"
            })

            if (response?.data?.success) {
                setCreditNotes(response?.data?.data);

                settotal_pages(response?.data?.total_pages);
                settoal_records(response?.data?.total_records);

                setNext(response?.data?.next);
                setPrev(response?.data?.prev);
            } else {
                console.log("error")
            }


        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }

    const getPageNumbers = () => {
        const pages = [];
        const total = total_pages;
        const windowSize = 5;

        let start = page;
        let end = page + windowSize - 1;
        if (end > total) {
            end = total;
            start = total - windowSize + 1;
        }
        if (start < 1) {
            start = 1;
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        return pages;
    };

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > total_pages) return;

        setPage(newPage);

        setSearchParams({
            page: newPage,
            limit: limit
        });

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);

        setLimit(newLimit);
        setPage(1);

        setSearchParams({
            page: 1,
            limit: newLimit
        });

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        GetCreditNotes();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [page, limit])

    useEffect(() => {
        setSearchParams(prev => {
            const params = new URLSearchParams(prev);
            params.set("page", page);
            params.set("limit", limit);
            return params;
        }, { replace: true });
    }, [page, limit]);

    return (
        <>
            {
                loading ?
                    <div style={{ height: "70vh" }}>
                        <OverlayLoader />
                    </div>
                    :
                    <main style={{ marginTop: '-10px' }}>
                        <PageTitle primary={"My Account"} title={"Credit Note"} />


                        <div className="container mt-2">
                            <h3 className={`account-sub-title d-none d-md-block mb-0`}>
                                <i className="sicon-credit-card align-middle mr-3" />
                                Credit Note
                            </h3>


                            <div className="order-table-container text-center mt-2">
                                <table className="table table-order text-left">
                                    <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Order Id</th>
                                            <th>Voucher ID</th>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>Amount</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {creditNotes?.length > 0 ? (
                                            creditNotes.map((item, index) => (
                                                <tr key={item.voucher_id}>

                                                    {/* Sr No */}
                                                    <td>
                                                        {((page - 1) * limit) + index + 1}
                                                    </td>

                                                    {/* Voucher ID */}
                                                    <td className='text-primary' style={{ fontWeight: "bold" }}>
                                                        {item.secret_order_id}
                                                    </td>

                                                    {/* Voucher ID */}
                                                    <td>
                                                        {item.voucher_id}
                                                    </td>

                                                    {/* Date */}
                                                    <td>
                                                        {dayjs(item.voucher_date).format("DD-MM-YYYY")}
                                                    </td>

                                                    {/* Status */}
                                                    <td className="text-success" style={{ fontWeight: "bold" }}>
                                                        Credit Note
                                                    </td>

                                                    {/* Amount */}
                                                    <td>
                                                        {item.amount} AED
                                                    </td>

                                                    {/* Action */}
                                                    <td>
                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            onClick={() => navigate(`/MyAccount/PreviewCreditNote/${item?.voucher_id}`)}
                                                        >
                                                            <i className="fa fa-eye"></i> View
                                                        </button>
                                                    </td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={7} className="text-center">
                                                    No Credit Notes Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={9}>

                                                <div className="d-flex justify-content-end align-items-center flex-wrap gap-2">

                                                    {/* Show entries info */}
                                                    <div className="show-entries">
                                                        Showing{" "}
                                                        {total_records === 0 ? 0 : (page - 1) * limit + 1}{" "}
                                                        to{" "}
                                                        {Math.min(page * limit, total_records)}{" "}
                                                        of {total_records} entries
                                                    </div>


                                                    {/* Right side controls */}
                                                    <div className="d-flex align-items-center gap-3">

                                                        {/* Pagination */}
                                                        <nav>
                                                            <ul className="custom-pagination mb-0">
                                                                <li
                                                                    className={`page-btn ${page === 1 ? "disabled" : ""}`}
                                                                    onClick={() => page > 1 && handlePageChange(1)}
                                                                >
                                                                    &laquo;
                                                                </li>

                                                                {/* Previous */}
                                                                <li
                                                                    className={`page-btn ${page === 1 ? "disabled" : ""}`}
                                                                    onClick={() => page > 1 && handlePageChange(page - 1)}
                                                                >
                                                                    &lt;
                                                                </li>

                                                                {/* Pages */}
                                                                {getPageNumbers().map((p, index) => (
                                                                    p === "..." ? (
                                                                        <li key={`dots-${index}`} className="page-btn dots">...</li>
                                                                    ) : (
                                                                        <li
                                                                            key={p}
                                                                            className={`page-btn ${p === page ? "active" : ""}`}
                                                                            onClick={() => handlePageChange(p)}
                                                                        >
                                                                            {p}
                                                                        </li>
                                                                    )
                                                                ))}

                                                                {/* Next */}
                                                                <li
                                                                    className={`page-btn ${page === total_pages ? "disabled" : ""}`}
                                                                    onClick={() => page < total_pages && handlePageChange(page + 1)}
                                                                >
                                                                    &gt;
                                                                </li>

                                                                <li
                                                                    className={`page-btn ${page === total_pages ? "disabled" : ""}`}
                                                                    onClick={() => page < total_pages && handlePageChange(total_pages)}
                                                                >
                                                                    &raquo;
                                                                </li>

                                                            </ul>
                                                        </nav>

                                                        <div className="d-flex align-items-center" style={{ marginLeft: "10px" }}>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                value={limit}
                                                                onChange={handleLimitChange}
                                                            >
                                                                <option value={50}>50</option>
                                                                <option value={100}>100</option>
                                                                <option value={150}>150</option>
                                                                <option value={200}>200</option>
                                                                <option value={250}>250</option>
                                                            </select>
                                                        </div>

                                                    </div>
                                                </div>


                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                        </div>

                    </main>
            }
        </>
    )
}

export default MyCreditNote
